﻿import React, { useState } from 'react';
import { GravimetricCalculationType } from '../models/enums';
import { BatchPlanningCalculation } from '../models/Calculations/batch-planning-calculation';
import { Decimal4Format } from '../templates/pw-formatting';
import { Uoms } from '../models/enums';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

import DataGrid, {
    Column,
    Paging,
    Toolbar,
    Selection,
    Item as ToolbarItem,
    LoadPanel
} from 'devextreme-react/data-grid';

export interface Props {
    batchPlanningCalculation?: BatchPlanningCalculation;
}

export default function BatchTargetWeightsData(props: Props) {
    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    let calculation = props.batchPlanningCalculation && props.batchPlanningCalculation.targetBatchWeightCalculation;

    /*
    let targetBatchSize = (props.batch && props.batch.plannedBatchSize ?
        props.batch.plannedBatchSize : 0) + totalRetentionSamplesNeeded;
    */

    let targetBatchSize = calculation && (calculation.plannedBatchSize ?
        calculation.plannedBatchSize : 0) + calculation.totalReservedSamples;

    return (
        <div>

            {calculation &&
                <div className="pw-form-section">
                    <div className="pw-comp-row">
                        <div className="pw-form-unit pw-comp-12">
                            <div className="pw-form-unit-label">Target Batch Size</div>
                            <div className="pw-readonly-label">{targetBatchSize ? targetBatchSize.toLocaleString("en-US") : 'NA'}</div>
                        </div>
                        <div className="pw-form-unit pw-comp-12">
                            <div className="pw-form-unit-label">Batch Size Multiplier </div>
                            <div className="pw-readonly-label">{calculation.batchSizeMultiplier}</div>
                        </div>
                        <div className="pw-form-unit pw-comp-12">
                            <div className="pw-form-unit-label">Unit Size UOM</div>
                            <div className="pw-readonly-label">{calculation.unitSizeUom ?
                                Uoms[calculation.unitSizeUom] : 'NA'}</div>
                        </div>
                    </div>

                    <div className="pw-comp-row">
                        <div className="pw-form-unit pw-comp-12">
                            <div className="pw-form-unit-label">Gravimetric Calculation</div>
                            <div className="pw-readonly-label">{calculation.gravimetricCalculation ?
                                GravimetricCalculationType[calculation.gravimetricCalculation] : 'NA'}</div>
                        </div>
                        <div className="pw-form-unit pw-comp-12">
                            <div className="pw-form-unit-label">Target Fill</div>
                            <div className="pw-readonly-label">{calculation.targetFill ? calculation.targetFill.toLocaleString("en-US") : 'NA'}</div>
                        </div>
                        <div className="pw-form-unit pw-comp-12">
                            <div className="pw-form-unit-label">Target Fill Uncertainty</div>
                            <div className="pw-readonly-label">{calculation.targetFillUncertainty}</div>
                        </div>
                    </div>

                    <div className="pw-comp-row">
                        <div className="pw-form-unit pw-comp-12">
                            <div className="pw-form-unit-label">Adjusted Volume</div>
                            <div className="pw-readonly-label">{calculation.adjustedVolume ?
                                calculation.adjustedVolume.toLocaleString("en-US") : 'NA'}</div>
                        </div>
                        <div className="pw-form-unit pw-comp-12">
                            <div className="pw-form-unit-label">Estimated Fill</div>
                            <div className="pw-readonly-label">{calculation && calculation.estimatedFill && calculation.estimatedFill.toLocaleString("en-US")}</div>
                        </div>
                    </div>

                    <div className="pw-comp-row">
                        <div className="pw-form-unit pw-comp-12">
                            <div className="pw-form-unit-label">Analytical Samples</div>
                            <div className="pw-readonly-label">{calculation.analyticalSamples}</div>
                        </div>
                        <div className="pw-form-unit pw-comp-12">
                            <div className="pw-form-unit-label">Stressed Samples</div>
                            <div className="pw-readonly-label">{calculation.stressedSamples}</div>
                        </div>
                        <div className="pw-form-unit pw-comp-12">
                            <div className="pw-form-unit-label">Retention Samples</div>
                            <div className="pw-readonly-label">{calculation.retentionSamples}</div>
                        </div>

                        <div className="pw-form-unit pw-comp-12">
                            <div className="pw-form-unit-label">Total Reserved Samples</div>
                            <div className="pw-readonly-label">{calculation.totalReservedSamples}</div>
                        </div>
                    </div>

                    <div className="pw-comp-row pw-margin-bottom-05">
                        <div className="pw-form-unit pw-comp-12">
                            <div className="pw-form-unit-label">Flask Volume (mL)</div>
                            <div className="pw-readonly-label">{calculation.flaskVolume ? calculation.flaskVolume.toLocaleString("en-US") : 'NA'}</div>
                        </div>

                        <div className="pw-form-unit pw-comp-12">
                            <div className="pw-form-unit-label">Est. Batch Density (g/mL)</div>
                            <div className="pw-readonly-label">{calculation.estimatedBatchDensity}</div>
                        </div>
                        <div className="pw-form-unit pw-comp-12">
                            <div className="pw-form-unit-label">Target Batch Weight (mg)</div>
                            <div className="pw-readonly-label">{calculation.targetBatchWeight ? calculation.targetBatchWeight.toLocaleString("en-US") : 'NA'}</div>
                        </div>
                    </div>
                </div>
            }

            <div className="pw-form-unit">
                <DataGrid
                    height="40em"
                    wordWrapEnabled={true}
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    dataSource={props.batchPlanningCalculation && props.batchPlanningCalculation.targetWeights ?
                        props.batchPlanningCalculation.targetWeights : []}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Selection mode='single' />
                    <Paging enabled={false} />

                    <Column dataField='elution' width='4rem' alignment='center' />
                    <Column dataField='vendorPartNumber' caption="Vendor Part#" width='7rem' />
                    <Column dataField='vendorPartName' width='16rem' />

                    <Column dataField='density' dataType="number"
                        format={Decimal4Format} width='6rem' />

                    <Column dataField='targetConcentrationPercent' dataType="number"
                        format={Decimal4Format} caption="Target Weight %" width='7rem' />

                    <Column dataField='percentConcentrationPpm'
                        dataType="number" format={Decimal4Format}
                        caption="% Conc. (PPM)" width='7rem' />

                    <Column dataField='percentAnalyte'
                        dataType="number" format={Decimal4Format}
                        caption="% Analyte" width='6rem' />

                    <Column dataField='purity' width='5rem' dataType="number" format={Decimal4Format} />
                    <Column dataField='targetWeight' width='7rem' dataType="number" format={Decimal4Format} />
                    <Column dataField='lowTarget' width='7rem' dataType="number" format={Decimal4Format} />
                    <Column dataField='highTarget' width='7rem' dataType="number" format={Decimal4Format} />
                    <Column />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Target Weights</div>
                            </div>
                        </ToolbarItem>
                    </Toolbar>

                </DataGrid>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }


    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}


